import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Button } from '@/components/UI/Button/Button';
import { headerBtnTextStyles } from '@/components/Header/Header.styles';

export const DesktopNewAdBtnBox = styled(CustomLink)`
  margin-right: 15px;
`;

export const DesktopNewAdBtn = styled(Button).attrs({
  appearance: 'green',
  hasPadding: false,
  borderRadius: 14,
})`
  height: 44px;
  padding: 13.5px;
  gap: 8px;
  border: 0;
  font-weight: 500;
  font-family: Arial;
  white-space: nowrap;

  @media (min-width: 1311px) {
    height: 43px;
    padding: 11px 15px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.system.deepGreen};
  }

  ${headerBtnTextStyles}
`;
